export default __webpack_public_path__ + "static/media/C_wdt_c_cap_1.df15fa7b.mp3";